module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-header-eca85192b9c3a8154d0a5c25c6f54d0c.jpg";